{
    "name": "outlook-add-in",
    "version": "1.0.12",
    "scripts": {
        "ng": "ng",
        "start": "ng serve --ssl true --port 3000",
        "dev-server": "webpack serve --mode development",
        "start-office": "office-addin-debugging start manifest.xml",
        "start-ssl": "ng serve --ssl true --ssl-cert \"ssl/server.crt\" --ssl-key \"ssl/server.key\"",
        "build": "ng build",
        "buildForTeamcity": "ng build --configuration %ENVIRONMENT%",
        "test": "ng test",
        "lint": "ng lint",
        "e2e": "ng e2e",
        "validate": "office-addin-manifest validate manifest.xml",
        "i18n:extract:all": "npm run i18n:extract && npm run i18n:extract:tools && npm run i18n:extract:form && npm run i18n:extract:reply && npm run i18n:extract:avatar",
        "i18n:extract": "ngx-translate-extract -i ./src/app -o ./src/assets/i18n/en.json --sort -f json --clean",
        "i18n:extract:tools": "ngx-translate-extract -i ./src/sb-tools -o ./src/sb-tools/assets/i18n/en.json --sort -f json --clean",
        "i18n:extract:form": "ngx-translate-extract -i ./src/sb-modules/Frontend-form-field-module -o ./src/sb-modules/Frontend-form-field-module/assets/i18n/en.json --sort -f json --clean",
        "i18n:extract:reply": "ngx-translate-extract -i ./src/sb-modules/Frontend-Reply-Templates-Module -o ./src/sb-modules/Frontend-Reply-Templates-Module/assets/i18n/en.json --sort -f json --clean",
        "i18n:extract:avatar": "ngx-translate-extract -i ./src/sb-modules/Frontend-User-Avatar-Module -o ./src/sb-modules/Frontend-User-Avatar-Module/assets/i18n/en.json --sort -f json --clean",
        "prepare": "husky install",
        "prettier": "npx prettier --write ."
    },
    "private": true,
    "dependencies": {
        "@ali-hm/angular-tree-component": "^12.0.5",
        "@angular/animations": "^20.3.1",
        "@angular/common": "^20.3.1",
        "@angular/compiler": "^20.3.1",
        "@angular/core": "^20.3.1",
        "@angular/forms": "^20.3.1",
        "@angular/localize": "^20.3.1",
        "@angular/platform-browser": "^20.3.1",
        "@angular/platform-browser-dynamic": "^20.3.1",
        "@angular/router": "^20.3.1",
        "@azure/msal-browser": "^4.26.2",
        "@ctrl/ngx-emoji-mart": "^7.1.0",
        "@ng-select/ng-select": "^10.0.4",
        "@ngx-translate/core": "^15.0.0",
        "@types/office-js": "^1.0.402",
        "angular2-notifications": "^16.0.1",
        "bootstrap": "^5.3.3",
        "deepmerge-ts": "^4.3.0",
        "intl-tel-input": "^25.11.2",
        "jquery": "^3.7.1",
        "ngx-avatars": "^1.8.0",
        "ngx-bootstrap": "^18.0.0",
        "ngx-dropzone-wrapper": "^14.0.0",
        "ngx-linky": "^4.0.0",
        "ngx-quill": "^26.0.5",
        "ngx-summernote": "^1.0.0",
        "ngx-translate-multi-http-loader": "^9.3.0",
        "quill": "^2.0.2",
        "quill-image-resize": "^3.0.9",
        "rxjs": "^7.8.1",
        "summernote": "^0.8.18",
        "tslib": "^2.6.3",
        "zone.js": "~0.15.1"
    },
    "devDependencies": {
        "@angular-devkit/build-angular": "^20.3.2",
        "@angular-eslint/builder": "^18.1.0",
        "@angular-eslint/eslint-plugin": "^18.1.0",
        "@angular-eslint/eslint-plugin-template": "^18.1.0",
        "@angular-eslint/schematics": "^18.1.0",
        "@angular-eslint/template-parser": "^18.1.0",
        "@angular/cli": "^20.3.2",
        "@angular/compiler-cli": "^20.3.1",
        "@angular/language-service": "^20.3.1",
        "@microsoft/applicationinsights-web": "^2.8.18",
        "@types/jasmine": "~3.6.0",
        "@types/jasminewd2": "^2.0.13",
        "@types/jquery": "^3.5.30",
        "@types/node": "^12.20.55",
        "@types/office-runtime": "^1.0.35",
        "@typescript-eslint/eslint-plugin": "^7.16.0",
        "@typescript-eslint/parser": "^7.16.0",
        "@vendure/ngx-translate-extract": "^10.1.3",
        "cross-env": "^7.0.3",
        "eslint": "^8.57.0",
        "eslint-config-prettier": "^9.1.0",
        "eslint-plugin-import": "^2.29.1",
        "eslint-plugin-jasmine": "^4.2.0",
        "eslint-plugin-jsdoc": "^48.7.0",
        "eslint-plugin-prettier": "^5.1.3",
        "html-loader": "^2.1.2",
        "html-webpack-plugin": "^5.6.0",
        "husky": "^8.0.3",
        "jasmine-core": "~3.6.0",
        "jasmine-spec-reporter": "~5.0.0",
        "karma": "^6.4.3",
        "karma-chrome-launcher": "^3.2.0",
        "karma-coverage-istanbul-reporter": "~3.0.2",
        "karma-jasmine": "^4.0.2",
        "karma-jasmine-html-reporter": "^1.5.0",
        "office-addin-debugging": "^4.6.7",
        "office-addin-dev-certs": "^1.13.3",
        "office-toolbox": "^0.3.0",
        "prettier": "^3.3.3",
        "prettier-eslint": "^16.3.0",
        "protractor": "~7.0.0",
        "ts-node": "~7.0.0",
        "typescript": "~5.8.3"
    }
}
